module.exports = __webpack_public_path__ + "media/images/countryrect/tr-26917da9802c6ac3d22a5eff2d7429ee.svg";